import React from "react";
import { Route, Switch } from "react-router-dom";

import AddCard from "./addCard/index";
import Verification from "./verification/verification.index";
import AuthVerification from "./verification/verify/verify.index";
import Profile from "./profile/index";
import Order from "./order/index";
import OrderS1IRTC from "./order/step1/irtc/orderIRTC.index";
import OrderVerify from "./order/verify/orderVerify.index";
import OrderS1CIRT from "./order/step1/cirt/orderCIRT.index";
import OrderS1CC from "./order/step1/cc/orderCC.index";
import OrderS1IRTM from "./order/step1/irtm/irtm.index";
import OrderS1CM from "./order/step1/cm/oderCM.index";
import OrderS1MIRT from "./order/step1/mirt/oderMIRT.index";
import OrderS1MC from "./order/step1/mc/orderMC.index";
import Ticket from "./ticket/index";
import CreateTicket from "./createticket/index";
import TicketDetail from "./ticketdetail/index";
import OrderHistory from "./orderhistory/index";
import Referral from "./referral/referral.index";

const UserPanel = ({ match }) => (
    <Switch>
        <Route path={`${match.url}/verficationresult`} component={AuthVerification} />
        <Route path={`${match.url}/addCard`} component={AddCard} />
        <Route path={`${match.url}/verification`} component={Verification} />
        <Route path={`${match.url}/referral`} component={Referral} />
        <Route path={`${match.url}/profile`} component={Profile} />
        <Route path={`${match.url}/order/IRTC`} component={OrderS1IRTC} />
        <Route path={`${match.url}/order/CIRT`} component={OrderS1CIRT} />
        <Route path={`${match.url}/order/CC`} component={OrderS1CC} />
        <Route path={`${match.url}/order/IRTM`} component={OrderS1IRTM} />
        <Route path={`${match.url}/order/CM`} component={OrderS1CM} />
        <Route path={`${match.url}/order/MIRT`} component={OrderS1MIRT} />
        <Route path={`${match.url}/order/MC`} component={OrderS1MC} />
        <Route path={`${match.url}/order/verify`} component={OrderVerify} />

        <Route path={`${match.url}/order`} component={Order} />
        <Route path={`${match.url}/orderhistory`} >
            <OrderHistory isAdmin={false} />
        </Route>
        <Route
            exact
            path={`${match.url}/ticket/create`}
            component={CreateTicket}
        />
        <Route
            exact
            path={`${match.url}/ticket/detail/:id`}
            component={TicketDetail}
        />
        <Route exact path={`${match.url}/ticket`} component={Ticket} />
    </Switch>
);

export default UserPanel;
